import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { getIsModified } from 'Common/GeneralHelper';

class DirtyWrapperContent extends Component {
  state = {
    showDialog: false,
    closeModalYesCallback: null,
    closeModalNoCallback: null,
    isSavePrompt: true,
  };

  componentDidUpdate(prevProps, prevState) {
    //this is needed to pass the dirty state backwards
    //to the parent (App) component so that we can
    //have a message if you attempt to leave and
    //have unsaved changes.
    //THIS IS NEEDED ON EVERY DIRTY CAPABLE FORM.
    const {
      isDirty,
      isReadOnly,
      setPageLevelDirty,
      ignorePageLevelDirty,
    } = this.props;

    if (!ignorePageLevelDirty && isDirty !== prevProps.isDirty) {
      setPageLevelDirty(isDirty && !isReadOnly ? true : false);
    }
  }

  showDirtyConfirm = ({ closeModalYesCallback, closeModalNoCallback } = {}) => {
    const {
      manual,
      isDirty,
      original,
      modified,
      ignoreEmptyStringToNull,
    } = this.props;

    if (
      ((!manual && isDirty) ||
        (manual &&
          getIsModified(original, modified, ignoreEmptyStringToNull))) &&
      !this.props.isReadOnly
    ) {
      this.setState({
        showDialog: true,
        closeModalYesCallback: () => {
          this.hideDirtyConfirm();
          this.props.closeModalYesCallback();
          if (closeModalYesCallback) {
            closeModalYesCallback();
          }
        },
        closeModalNoCallback: () => {
          this.hideDirtyConfirm();
          this.props.closeModalNoCallback();
          if (closeModalNoCallback) {
            closeModalNoCallback();
          }
        },
      });
    } else {
      this.props.closeModalYesCallback();
    }
  };

  showNewDataDirtyConfirm = studentObj => {
    if (
      ((!this.props.manual && this.props.isDirty) ||
        (this.props.manual &&
          getIsModified(
            this.props.original,
            this.props.modified,
            this.props.ignoreEmptyStringToNull
          ))) &&
      !this.props.isReadOnly
    ) {
      this.setState({
        showDialog: true,
        closeModalYesCallback: () => {
          this.hideDirtyConfirm();
          if (this.props.changeStatus) {
            this.props.changeStatus(true);
          }

          this.props.showNewDataYesCallback(studentObj);
        },
        closeModalNoCallback: () => {
          this.hideDirtyConfirm();
          if (this.props.changeStatus) {
            this.props.changeStatus(false);
          }
        },
      });
    } else {
      this.props.showNewDataYesCallback(studentObj);
    }
  };

  showLinkDirtyConfirm = (path, optionalCallback = null) => {
    const {
      history,
      setPageLevelDirty,
      manual,
      original,
      modified,
      isDirty,
      ignoreEmptyStringToNull,
    } = this.props;

    if (
      (isDirty ||
        (manual &&
          getIsModified(original, modified, ignoreEmptyStringToNull))) &&
      !this.props.isReadOnly
    ) {
      this.setState({
        showDialog: true,
        closeModalYesCallback: () => {
          if (optionalCallback) {
            optionalCallback();
          }
          history.push(path);
          setPageLevelDirty(false); //TODO: Maybe not needed with route change clearing dirty now?
        },
        closeModalNoCallback: this.hideDirtyConfirm,
      });
    } else {
      if (optionalCallback) {
        optionalCallback();
      }
      setPageLevelDirty(false);
      history.push(path);
    }
  };

  hideDirtyConfirm = () => {
    this.setState({ showDialog: false });
  };

  render() {
    return (
      <Fragment>
        <YesNoDialog
          isSavePrompt
          noCallback={this.state.closeModalNoCallback}
          question={this.props.question}
          showDialog={this.state.showDialog}
          yesCallback={this.state.closeModalYesCallback}
        />
        {this.props.children(
          this.showDirtyConfirm,
          this.showLinkDirtyConfirm,
          this.showNewDataDirtyConfirm
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { getPageLevelDirty, watchedForm, ignorePageLevelDirty } = ownProps;

  return {
    isDirty:
      (!ignorePageLevelDirty && getPageLevelDirty()) ||
      getIsDirty(watchedForm)(state),
  };
};

DirtyWrapperContent = connect(mapStateToProps)(DirtyWrapperContent);

DirtyWrapperContent.propTypes = {
  closeModalYesCallback: PropTypes.func,
  closeModalNoCallback: PropTypes.func,
  history: PropTypes.object,
  ignoreEmptyStringToNull: PropTypes.bool,
  ignorePageLevelDirty: PropTypes.bool,
};

DirtyWrapperContent.defaultProps = {
  closeModalYesCallback: () => {},
  closeModalNoCallback: () => {},
  ignorePageLevelDirty: true,
  ignoreEmptyStringToNull: true,
};

export { DirtyWrapperContent };



// WEBPACK FOOTER //
// ./src/components/tracked/DirtyWrapperContent.js